<template>
    <div class="contactUs">
        <banner type="6"></banner>
        <div class="w-1200 contactType flex">
            <div><img src="../assets/img/dizhi.png" width="100" height="100" alt=""></div>
            <div class="ml-8">
                <div>
                    <span class="w-4em font-600 color-red">电话：</span>
                    <span class="ml-2">{{contact.users}}</span>
                </div>
                <div class="mt-8">
                    <span class="w-4em font-600 color-red">邮箱：</span>
                    <span class="ml-2">{{contact.email}}</span>
                </div>
                <div class="mt-8">
                    <span class="w-4em font-600 color-red">地址：</span>
                    <span class="ml-2">{{contact.address}}</span>
                </div>
            </div>

        </div>
        <div class="w-1200 contactForm">
            <div class="font-600 font-20 color-red">
                您有什么需要跟我们说？
            </div>
            <div class="mt-8 flex position-r">
                <span class="w-7em">姓名:</span>
                <input type="text" v-model="form.username" placeholder="请输入您的姓名,方便我们称呼您">
                <img class="xinhao" src="../assets/img/xinhao.png" width="16" height="16" alt="">
            </div>
            <div class="mt-8 flex position-r">
                <span class="w-7em">邮箱:</span>
                <input type="text" v-model="form.email" placeholder="请输入您发邮箱地址，我们将会发送回复给您">
                <img class="xinhao" src="../assets/img/xinhao.png" width="16" height="16" alt="">
            </div>
            <div class="mt-8 flex position-r">
                <span class="w-7em">联系方式:</span>
                <input type="text" v-model="form.mobile" placeholder="请输入您的手机号码，方便我们联系您">
                <img class="xinhao" src="../assets/img/xinhao.png" width="16" height="16" alt="">
            </div>
            <div class="mt-8 flex position-r">
                <span class="w-7em">地址:</span>
                <input type="text" v-model="form.address" placeholder="请输入您的办公地址，如有需要，我们可上门拜访">
                <img class="xinhao" src="../assets/img/xinhao.png" width="16" height="16" alt="">
            </div>
            <div class="mt-8 flex">
                <span class="w-7em">您的留言:</span>
                <textarea v-model="form.content" placeholder="请输入您的留言，我们竭诚为您服务"/>
            </div>
            <div class="mt-50" style="float: right;">
                <div class="flex flex-j-c flex-a-c" @click="submit"
                     style="width: 214px;height: 64px;background: #BD2C2E;border-radius: 32px;color: #fff;">
                    <img src="../assets/img/fasong.png" width="28" height="28" alt="">
                    <span class="ml-2 font-600">发送</span>
                </div>
            </div>
        </div>
        <div v-if="toast" class="text-center flex flex-j-c flex-a-c"
             style="color:#fff;width: 214px;height: 50px;background: #000000;border-radius: 8px;opacity: 0.5;line-height: 50px;
                    position: fixed;left: 50%;bottom: 300px;z-index: 1000;">
            <img v-if="toast == '发送成功'" src="../assets/img/queding.svg" alt="">
            <span class="ml-2">{{toast}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contactUs',
        props: {},
        data() {
            return {
                contact: {},
                form: {},
                toast: ''
            }
        },
        async mounted() {
            this.getContact()
        },
        methods: {
            async getContact() {
                this.contact = await this.$api.getContact()
            },
            async submit() {
                let data = await this.$api.addMessage(this.form)
                if (data.code) {
                    this.toast = '发送成功'
                } else {
                    this.toast = data.info
                }
                setTimeout(() => {
                    this.toast = ''
                }, 3000)
            }
        },

    }
</script>
<style scoped lang="scss">
    .contactUs {
        .contactType {
            height: 480px;
            padding-top: 100px;
            padding-bottom: 100px;

            .w-4em {
                display: inline-block;
                width: 4em;
            }
        }

        .contactForm {
            padding-top: 100px;
            padding-bottom: 100px;
            height: 950px;
            background-color: $grey;

            .w-7em {
                display: inline-block;
                width: 7em;
            }

            input {
                width: 1030px;
                height: 62px;
                background: #FFFFFF;
                border: 1px solid #E3E6E8;
                padding: 15px 30px;
                box-sizing: border-box;
                position: relative;
            }

            .xinhao {
                position: absolute;
                right: 50px;
                top: 25px;
            }

            textarea {
                width: 1030px;
                height: 129px;
                padding: 15px 30px;
                box-sizing: border-box;
                background: #FFFFFF;
                border: 1px solid #E3E6E8;
            }
        }

    }
</style>
